<template>
  <layout-component>
    <div class="container">
      <div class="row form-wrapper pb-4 pb-md-2">
        <div class="col-md-7 col-lg-8 form form-login">
          <h1 class="br-title left-bullet" v-html="$t('w.password-reset.title-banner')"></h1>
          <div class="row">
            <div class="col-lg-9">

              <b-alert :show="has_error && !success" fade variant="danger">
                <h4><i class="fal fa-times"></i> {{'w.password-reset.error-title'|t}}.</h4>
                <p>{{'w.password-reset.error-text'|t}}</p>
              </b-alert>


              <form autocomplete="off" @submit.prevent="send" method="post">
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                        <label for="email">{{'w.password-reset.email-address'|t}} <span class="required">*</span></label>
                        <div class="input-wrapper">
                          <input type="email" id="email" class="form-control" placeholder="user@example.com" v-model="email" required>
                          <span class="focus-border"></span>
                        </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm">
                    <div class="form-group" :class="{ 'has-error': has_error && errors.password }">
                        <label for="password">{{'w.password-reset.label-password'|t}} <span class="required">*</span></label>
                        <div class="input-wrapper">
                          <input type="password" id="password" class="form-control" v-model="password" required>
                          <span class="focus-border"></span>
                        </div>
                        <small class="form-text text-danger" v-if="has_error && errors.password" v-html="errors.password.join('<br />')"></small>
                    </div>
                  </div>
                  <div class="col-sm">
                    <div class="form-group" :class="{ 'has-error': has_error && errors.password }">
                        <label for="password_confirmation">{{'w.password-reset.label-password-confirmation'|t}} <span class="required">*</span></label>
                        <div class="input-wrapper">
                          <input type="password" id="password_confirmation" class="form-control" v-model="password_confirmation" required>
                          <span class="focus-border"></span>
                        </div>
                    </div>
                  </div>
                </div>
                <div class="d-flex align-items-center pt-2">
                  <button type="submit" class="btn btn-primary mt-0"><span>{{'w.password-reset.btn-submit'|t}}</span></button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

    </div>
	</layout-component>
</template>

<script>
  export default {
    data() {
      return {
        email: null,
        password: null,
        password_confirmation: null,
        token: null,
        has_error: false,
        success: false,
        redirectTo: null
      }
    },

    mounted() {
      $('.title-anim-wrapper:in-viewport').addClass('in-viewport')
      this.token = this.$route.params.token
    },

    methods: {
      send() {
        Vue.axios.post('/password/reset', {
          email: this.email,
          password: this.password,
          password_confirmation: this.password_confirmation,
          token: this.token
        }).then(({data}) => {
          this.$router.push('login')
        })
      }
    }
  }
</script>
